import PropTypes from 'prop-types';
import { formatDistanceToNowStrict } from 'date-fns';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import useAuth from 'src/hooks/useAuth';
// components

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  marginBottom: theme.spacing(3),
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 320,
  padding: theme.spacing(1.5),
  marginTop: theme.spacing(0.5),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.neutral,
}));

const InfoStyle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  marginBottom: theme.spacing(0.75),
  color: theme.palette.text.secondary,
}));

// ----------------------------------------------------------------------

ChatMessageItem.propTypes = {
  message: PropTypes.object.isRequired,
  participants: PropTypes.array.isRequired,
};

export default function ChatMessageItem({ message, participants }) {
  const { user } = useAuth();

  const sender = participants.find(
    (participant) => participant.id_usuario === message.id_usuario,
  );

  const senderDetails =
    message.id_usuario === user.user_id
      ? { type: 'me' }
      : { name: sender?.usuario };

  const isMe = senderDetails.type === 'me';
  const senderName = senderDetails.name;

  return (
    <RootStyle>
      <Box
        sx={{
          display: 'flex',
          ...(isMe && {
            ml: 'auto',
          }),
        }}
      >
        <div>
          <InfoStyle
            variant="caption"
            sx={{
              ...(isMe && { justifyContent: 'flex-end' }),
            }}
          >
            {!isMe && `${senderName},`}&nbsp;
            {formatDistanceToNowStrict(new Date(message.fecha), {
              addSuffix: true,
            })}
          </InfoStyle>

          <ContentStyle
            sx={{
              ...(isMe && { color: 'grey.800', bgcolor: 'primary.lighter' }),
            }}
          >
            <Typography variant="body2">{message.mensaje}</Typography>
          </ContentStyle>
        </div>
      </Box>
    </RootStyle>
  );
}
